import React, { useEffect, useState } from 'react'
import { Parallax as UDSParallax } from '@telus-uds/components-community.parallax'

export type ParallaxProps = {
  sections: ParallaxSectionProps[]
  reverseColumns: boolean
  isSingleColumn?: boolean
}

type ParallaxSectionProps = {
  leftChild: React.ReactNode
  rightChild: React.ReactNode
}

const Parallax = ({ sections, reverseColumns, isSingleColumn = false }: ParallaxProps) => {
  const [reducedMotion, setPrefersReducedMotion] = useState(false)

  useEffect(() => {
    setPrefersReducedMotion(window.matchMedia('(prefers-reduced-motion: reduce)').matches)
    window.dispatchEvent(new Event('resize'))
  }, [])

  return (
    <UDSParallax
      sections={sections}
      reduceMotion={reducedMotion}
      reverseColumns={reverseColumns}
      isSingleColumn={isSingleColumn}
    />
  )
}

export default Parallax
